// eslint-disable-next-line import/no-unresolved
import PropTypes from 'prop-types';
import React from 'react';

import { UiEmbed, Webcam } from '@powdr/components';
import { getHdRelaySrc, getImageAltText } from '@powdr/utils';

import {
  StyledSlideItem, SlideImageStatic, SlideImageDynamic,
} from './styles';

export const SlideItem = ({
  id,
  embeddedVideoLink = null,
  staticImage = null,
  staticImageUrlObj = null,
  disabled = false,
  isAutoplay = false,
  webcamGuid = null,
  relationships,
}) => {
  const image = relationships?.primaryImage?.relationships?.image?.gatsbyImage || null;
  const imageAlt = getImageAltText(relationships?.primaryImage?.relationships?.image);
  const staticImageSrc = staticImageUrlObj?.uri || staticImage || null;
  const hasHdRelayCam = Boolean(getHdRelaySrc(relationships));
  const hasWebcam = hasHdRelayCam || Boolean(webcamGuid);

  return (
    <StyledSlideItem>
      {(embeddedVideoLink && !hasWebcam) && (
        <UiEmbed
          videoLink={embeddedVideoLink}
          disabled={disabled}
          isAutoplay={isAutoplay}
        />
      )}
      {hasWebcam && (
        <Webcam
          id={id}
          webcamGuid={webcamGuid}
          relationships={relationships}
          disabled={disabled}
          fallbackImage={image}
          fallbackImageSrc={staticImageSrc}
          fallbackImageAlt={imageAlt}
        />
      )}
      {(image && !hasWebcam) && (
        <SlideImageDynamic
          image={image}
          alt={imageAlt}
        />
      )}
      {(!image && staticImageSrc && !hasWebcam) && <SlideImageStatic src={staticImageSrc} alt="" />}
    </StyledSlideItem>
  );
};

SlideItem.propTypes = {
  id: PropTypes.string.isRequired,
  embeddedVideoLink: PropTypes.string,
  staticImage: PropTypes.string,
  staticImageUrlObj: PropTypes.shape({
    uri: PropTypes.string,
  }),
  isAutoplay: PropTypes.bool,
  disabled: PropTypes.bool,
  webcamGuid: PropTypes.string,
  relationships: PropTypes.shape().isRequired,
};
